module.exports = __webpack_public_path__ + "img/15-02_Communicating Well (Written).cde55bad.svg";